import classNames from 'classnames'
import { Icon } from 'components/common/Icon'
import { Tag } from 'components/common/Tag'
import { Title } from 'components/onboarding/Typography'
import { ONBOARDING_STEPS_COUNT } from 'constants/onboarding'
import { useOnboarding } from 'contexts/hooks/useOnboarding'
import useTranslation from 'next-translate/useTranslation'
import { PropsWithChildren } from 'react'
import { PropsWithClassName } from 'types'

interface Props extends PropsWithChildren {
  step: number
}

export function OnboardingScreenHeader({ step, children }: Props) {
  const { t } = useTranslation('onboarding')
  const { skip, prev } = useOnboarding()

  return (
    <div className='sm:space-y-1 sm:px-8 sm:py-6 sm:pb-4 sm:border-b sm:bg-cool-50 sm:border-cool-400'>
      <button
        type='button'
        title='skip'
        onClick={skip}
        className='text-cool-600 hidden sm:block absolute right-6 top-6'
      >
        <Icon name='close' />
      </button>

      <div className='flex items-center justify-between bg-cool-50 border-b border-cool-400 sm:bg-transparent sm:border-none py-6 px-8 sm:p-0'>
        <button
          type='button'
          className='text-cool-700 font-medium space-x-1 flex items-center sm:hidden'
          onClick={prev}
        >
          <Icon name='arrow-chevron-back' size={20} />
          <span>{t('common:back')}</span>
        </button>

        <div className='flex items-center space-x-4 sm:justify-between sm:w-full'>
          <Tag icon={null} color='light-purple'>
            {t('step_x_of_y', { x: step, y: ONBOARDING_STEPS_COUNT })}
          </Tag>

          <button
            type='button'
            title='Close'
            onClick={skip}
            className='text-cool-900  sm:hidden'
          >
            <Icon name='close' />
          </button>
        </div>
      </div>

      {children}
    </div>
  )
}

interface OnboardingScreenTitlesProps extends PropsWithClassName {
  title?: string
  description?: string
}

export function OnboardingScreenTitles({
  title,
  description,
  className,
}: OnboardingScreenTitlesProps) {
  return (
    <div className={classNames(className, 'w-full space-y-1 sm:max-w-[20rem]')}>
      {title && <Title>{title}</Title>}

      {description && <p className='text-sm text-cool-600'>{description}</p>}
    </div>
  )
}
